// extracted by css-extract-rspack-plugin
export default {"cls1":"Autocomplete-cls1_jEu","cls2":"Autocomplete-cls2_xA1 Autocomplete-cls1_jEu","active":"Autocomplete-active_Ttg"};